module.exports = __webpack_public_path__ + "img/logo_revista_pregoeiro_grande.704fc801.png";